module.exports = " <div class=\"report-main-content-wrap layout_report block_cp\">\n      <router-outlet></router-outlet>\n</div>"